import { isValidPrice } from '@domain-group/javascript-utils'

export type OrderModel = {
  agency_id: number,
  cache_key: number,
  campaign_id: number,
  campaign_proposal_id?: number,
  campaign_quote_id?: number,
  campaign_quote_item_id?: number,
  coupon_id?: number,
  data: {
    unapprove_reason?: string,
  },
  dates: {
    approval: {
      date_time: string,
    },
    created: {
      date_time: string,
    },
  },
  deleted?: boolean,
  id: number,
  invoice_date?: string,
  invoice_notes?: string,
  invoice_reference?: string,
  invoice_total?: number,
  invoiced?: boolean,
  items?: number[],
  notes?: string,
  order_bundle_id?: number,
  order_type: string,
  override_reason?: string,
  owner_id: number,
  owner_type: string,
  pagination_approved?: boolean,
  paid_by?: string,
  priority_campaign_user_ids?: number[],
  provider_id: number,
  publication_booking_id?: number,
  publication_edition_id?: number,
  publication_id?: number,
  publication_package_id?: number,
  purchase_order?: string,
  shipping_address?: string,
  status_id: number,
  title: string,
  total: number,
  total_override?: number,
  user_id: number,
}

const state = {
  agency_id: null,
  campaign_id: null,
  id: null,
  invoice_date: '',
  invoice_notes: '',
  invoice_reference: '',
  invoice_total: undefined,
  data: {
    unapprove_reason: '',
  },
  order_type: '',
  override_reason: '',
  paid_by: '',
  provider_id: null,
  shipping_address: '',
  title: '',
  total_override: null,
  total: null,
  user_id: null,
}

export const requiredFields = [
  { key: 'agency_id' },
  { key: 'order_type' },
  { key: 'provider_id' },
  { key: 'title' },
  { key: 'total', validation: isValidPrice, invalidMessage: 'Invalid Price' },
  { key: 'user_id' },
]

export type OrderRequestOptions = {
  allow_provider_orders?: boolean,
  exclude_hidden_campaigns?: boolean,
  include_attachment_file?: boolean,
  include_order_bundle_items?: boolean,
  include_order_campaign?: boolean,
  include_order_item_agency?: boolean,
  include_order_item_agents?: boolean,
  include_order_item_artwork?: boolean,
  include_order_item_attachments?: boolean,
  include_order_item_due_date?: boolean,
  include_order_item_service?: boolean,
  include_order_items?: boolean,
  include_order_publication_edition?: boolean,
  include_order_publication?: boolean,
  include_order_priority_campaign_user_ids?: boolean,
}

export default state
